/**
 * "Trouvez votre routine" quiz — vanilla JS state machine, no dependencies.
 * Branching: Q1 (single gesture / full routine) → Q2 only on the full-routine
 * path (priority) → Q3 (sensitive skin, both paths) → result.
 */
(function () {
  var FADE_MS = 260;

  document.querySelectorAll('[data-quiz]').forEach(function (root) {
    var questions = root.querySelectorAll('[data-quiz-question]');
    var results = root.querySelectorAll('[data-quiz-result]');
    var progressBar = root.querySelector('[data-quiz-progress]');
    var restartBtn = root.querySelector('[data-quiz-restart]');
    var sensitiveNote = root.querySelector('[data-quiz-sensitive-note]');

    var state = { step: 1, path: null, q2: null };

    function totalSteps() {
      return state.path === 'a' ? 2 : 3;
    }

    function updateProgress() {
      if (!progressBar) return;
      var pct = Math.min(100, Math.round((state.step / totalSteps()) * 100));
      progressBar.style.width = pct + '%';
    }

    function currentActive() {
      var active = null;
      questions.forEach(function (q) {
        if (!q.hidden) active = q;
      });
      results.forEach(function (r) {
        if (!r.hidden) active = r;
      });
      return active;
    }

    function swapTo(target) {
      var current = currentActive();

      function reveal() {
        target.hidden = false;
        target.style.opacity = '0';
        target.style.transform = 'translateY(8px)';
        // Force layout so the transition actually runs.
        target.getBoundingClientRect();
        requestAnimationFrame(function () {
          target.style.opacity = '1';
          target.style.transform = 'translateY(0)';
        });
      }

      if (!current || current === target) {
        reveal();
        return;
      }

      current.style.opacity = '0';
      current.style.transform = 'translateY(-8px)';
      window.setTimeout(function () {
        current.hidden = true;
        reveal();
      }, FADE_MS);
    }

    function showResult() {
      var key = state.path === 'a' ? 'result_a' : 'branch_' + state.q2;
      var panel = root.querySelector('[data-quiz-result="' + key + '"]');
      if (!panel) return;

      if (sensitiveNote) sensitiveNote.hidden = true;
      if (key === 'branch_renewal' && sensitiveNote && state.sensitiveSkin === 'yes') {
        sensitiveNote.hidden = false;
      }

      swapTo(panel);
      if (progressBar) progressBar.style.width = '100%';
      if (restartBtn) restartBtn.hidden = false;
    }

    root.addEventListener('click', function (event) {
      var option = event.target.closest('[data-quiz-answer]');
      if (option) {
        var question = option.getAttribute('data-quiz-answer');
        var value = option.getAttribute('data-quiz-value');

        if (question === 'q1') {
          state.path = value; // 'a' or 'b'
          state.step = 2;
          updateProgress();
          swapTo(root.querySelector('[data-quiz-question="' + (value === 'a' ? 'q3' : 'q2') + '"]'));
        } else if (question === 'q2') {
          state.q2 = value;
          state.step = 3;
          updateProgress();
          swapTo(root.querySelector('[data-quiz-question="q3"]'));
        } else if (question === 'q3') {
          state.sensitiveSkin = value;
          showResult();
        }
        return;
      }

      if (event.target.closest('[data-quiz-restart]')) {
        state = { step: 1, path: null, q2: null };
        results.forEach(function (r) {
          r.hidden = true;
        });
        questions.forEach(function (q) {
          q.hidden = q.getAttribute('data-quiz-question') !== 'q1';
        });
        var q1 = root.querySelector('[data-quiz-question="q1"]');
        q1.style.opacity = '1';
        q1.style.transform = 'translateY(0)';
        if (restartBtn) restartBtn.hidden = true;
        if (progressBar) progressBar.style.width = '50%';
      }
    });

    updateProgress();
  });
})();
